import React from "react";
import ModuleHome from "../template/TrackHome";

export default () => <ModuleHome />;
